import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Item, ItemMovement, ItemSearchParams, PageableItems2, ItemGroup, ItemEdit, BulkItemUpdateRequest } from '../domain/inventory.model';

@Injectable({
  providedIn: 'root'
})
export class ItemService {
  private apiUrl = environment.apiUrl + '/api/v1/item';
  private releaseApiUrl = environment.apiUrl + '/api/v1/release-groups';
  private itemGroupApiUrl = environment.apiUrl + '/api/v1/itemGroup';

  constructor(private http: HttpClient) { }

  validateSimpleCode(warehouse: string, code: string): Observable<boolean> {
    const params = new HttpParams()
      .set('code', code);
    return this.http.get<boolean>(`${this.apiUrl}/${warehouse}/validate`, { params });
  }

  validateEdit(code: string): Observable<ItemEdit> {
    const encodedCode = encodeURIComponent(code);
    return this.http.get<ItemEdit>(`${this.apiUrl}/${encodedCode}/editable`, {});
  }

  getItems(warehouse: string, page: number, size: number, sortField: string, sortOrder: string): Observable<PageableItems2> {
    const params = {
      page: page.toString(),
      size: size.toString(),
      sort: sortField,
      order: sortOrder
    };

    return this.http.get<PageableItems2>(`${this.apiUrl}/${warehouse}`, { params });
  }

  searchItems(params: ItemSearchParams): Observable<{ content: Item[]; totalElements: number }> {
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        httpParams = httpParams.set(key, value.toString());
      }
    });

    return this.http.get<{ content: Item[]; totalElements: number }>(`${this.apiUrl}/search/${params['warehouse']}`, { params: httpParams });
  }

  deactivateItems(itemId: number, data: { quantity: number, note: string }): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/${itemId}/deactivate`, data);
  }

  deleteItem(itemId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${itemId}`);
  }

  releaseItems(data: any): Observable<void> {
    return this.http.post<void>(this.releaseApiUrl, data);
  }

  getItemGroups(accountId: number, warehouse: string): Observable<ItemGroup[]> {
    const params = {
      warehouse: warehouse,
      accountId: accountId
    };
    return this.http.get<ItemGroup[]>(this.itemGroupApiUrl, { params });
  }

  getItemMovements(itemId: number): Observable<ItemMovement[]> {
    return this.http.get<ItemMovement[]>(`${this.apiUrl}/${itemId}/movements`);
  }

  deleteItemGroup(id: number): Observable<void> {
    return this.http.delete<void>(`${this.itemGroupApiUrl}/${id}`);
  }

  getItemsFromGroup(groupId: number): Observable<ItemGroup> {
    return this.http.get<ItemGroup>(`${this.itemGroupApiUrl}/${groupId}`);
  }

  bulkUpdate(items: BulkItemUpdateRequest): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/bulk-update`, items);
  }

  formatFieldName(key: string): string {
    const labels: Record<string, string> = {
      serialNumber: 'SKU',
      description: 'Descripción',
      quantity: 'Cantidad'
    };
    return labels[key] || key;
  }

  formatFieldValue(value: any): string {
    return value ?? 'null';
  }

}
